function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardList = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _Pagination = require("../Pagination");
var _styles2 = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["visibleItems", "items", "emptyMessage", "style", "ItemTemplate"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var CardList = exports.CardList = (0, _react.memo)(function (_ref) {
  var visibleItems = _ref.visibleItems,
    items = _ref.items,
    emptyMessage = _ref.emptyMessage,
    style = _ref.style,
    ItemTemplate = _ref.ItemTemplate,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _page = _useState2[0],
    _setPage = _useState2[1];
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  var _visibleItems = visibleItems ? visibleItems : bp.is([bp.tablet, bp.desktop]) ? 8 : 4;
  var _hasItems = !!items && items.length > 0 && !!ItemTemplate;
  var _isSingle = _hasItems && items.length === 1;
  var _showPagination = !!_visibleItems && _hasItems && items.length > _visibleItems;
  (0, _react.useEffect)(function () {
    _setPage(0);
  }, [items]);
  if (!_hasItems && !emptyMessage) return null;
  if (!_hasItems) {
    return (0, _jsxRuntime.jsx)(_reactNative.View, Object.assign({
      style: [styles.container, style],
      testID: "CardList"
    }, props, {
      children: (0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: styles.emptyMessage,
        children: emptyMessage
      })
    }));
  }
  return (0, _jsxRuntime.jsxs)(_reactNative.View, Object.assign({
    style: [styles.container, style],
    testID: "CardList"
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_reactNative.View, {
      style: [styles.grid, _isSingle && styles.grid_single],
      children: items.slice(_visibleItems * _page, _visibleItems * _page + _visibleItems).map(function (item) {
        return (0, _jsxRuntime.jsx)(_reactNative.View, {
          style: [styles.gridItem, _isSingle && styles.gridItem_single],
          children: (0, _jsxRuntime.jsx)(ItemTemplate, {
            item: item,
            style: styles.gridItemTemplate
          })
        }, "cardList-".concat(item.id));
      })
    }), _showPagination && (0, _jsxRuntime.jsx)(_Pagination.Pagination, {
      currentItem: _page,
      totalItems: Math.ceil(items.length / _visibleItems),
      label: "",
      isNumbered: true,
      showEllipsis: true,
      onPress: _setPage
    })]
  }));
});